namespace Portico.Models.Setup {

    export interface IDataValue {
		id: string;
		dataRowId: string;
		dataColumnId: string;
        value: string;
		createdBy: number;
		createdOn: Date;
		isDeleted: boolean;
    }

    export class DataValue implements IDataValue {
		id: string;
		dataRowId: string;
		dataColumnId: string;
        value: string;
		createdBy: number;
		createdOn: Date;
		isDeleted: boolean;

        constructor(obj?: IDataValue) {
            this.id = null;
            this.dataRowId = null;
            this.dataColumnId = null;
            this.value = null;
			this.createdBy = null;
			this.createdOn = null;
			this.isDeleted = false;

            if (obj) {
                this.id = obj.id;
                this.dataRowId = obj.dataRowId;
                this.dataColumnId = obj.dataColumnId;
                this.value = obj.value;
				this.createdBy = obj.createdBy;
				this.createdOn = obj.createdOn ? new Date(typeof obj.createdOn === 'string' && (<string>obj.createdOn).charAt(10) === 'T' ? obj.createdOn + 'Z' : obj.createdOn) : null;
				this.isDeleted = obj.isDeleted;
            }
        }
    }
}